export const getPaymentStatus = (totalDeposits, totalAmount) => {
  if (totalDeposits === 0) return 'unpaid';
  if (totalDeposits >= totalAmount) return 'paid';
  return 'partial';
};

export const calculateNights = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return 0;
  const checkInDate = new Date(checkIn);
  const checkOutDate = new Date(checkOut);
  const diffTime = Math.abs(checkOutDate.getTime() - checkInDate.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const formatCurrency = (amount) => {
  return `${amount.toLocaleString()} ج.م`;
};

export const calculateRefund = (totalDeposits, newTotalAmount, previousTotalAmount) => {
  if (!previousTotalAmount || newTotalAmount >= previousTotalAmount) return 0;
  return totalDeposits > newTotalAmount ? totalDeposits - newTotalAmount : 0;
};

export const getAmountChangeType = (newAmount, previousAmount) => {
  if (newAmount > previousAmount) return 'increase';
  if (newAmount < previousAmount) return 'decrease';
  return 'same';
};
